export default __webpack_public_path__ + "static/media/逄愛君.86d98105.jpg";